//AllAround JS
//2020 Pablo Albornoz Afanasiev

import "../css/global.css";

jQuery(function ($) {
  window.loaded = 0;

  window.menuclickable = false;
  let heroResizeTimer;
  const HEADER_RESPONSIVE_BREAKPOINT = 782;

  /*=========================ON LOAD==========================================*/

  jQuery(document).ready(function () {
    aspam_function();
    window.loaded = 100;
    is_loaded(function () {
      randomize_hero_stripes();
      hero_background();
      //header_responsive();
      // aa_toggle_responsive_menu(); //  ToDo
      // aa_toggle_submenu(); // ToDo
      // hamburger_menu();
      move_compass();
      lang_navigation();
      // aa_toggle_responsive_menu_v2(); //  ToDo
      hide_empty_blog();

      setTimeout(function () {
        $("body").addClass("loaded");
      }, 400);

      setTimeout(function () {
        $("#compass_container").addClass("nodelay");
      }, 400);
      $(".home_hero h2").each(function () {
        showup($(this), 0.9);
      });
      $(".showup").each(function () {
        showup($(this), 0.9);
      });

      $("#menu_btn").click(function () {
        //aa_move_submenu_on_hover(jQuery("#aa_responsive_slider_nav"));
      });

      $(".vertical_scrolling").each(function () {
        // target, container, direction, axis, speed, type
        parallax_scroll($(this).find("img"), $(this), -1, "y", 1, "image");
        parallax_scroll($(this).find("img"), $(this), 1, "y", 1, "image");
      });
      jQuery(window)
        .off("resize.aaHeroBg")
        .on("resize.aaHeroBg", function () {
          clearTimeout(heroResizeTimer);
          heroResizeTimer = setTimeout(function () {
            hero_background();
          }, 120);
        });
      jQuery(window)
        .off("load.aaHeroBg")
        .on("load.aaHeroBg", function () {
          hero_background();
        });

      setTimeout(function () {
        hero_background();
      }, 120);

      if (!jQuery("body").hasClass("single-post")) {
        scrollTo();
      }
      jQuery(".back-to-top-link a").click(function (e) {
        e.preventDefault();
        jQuery("html, body").stop(true).animate({ scrollTop: 0 }, 600);
      });

    });
  }); //Fin Ready

  //Functions

  function is_loaded(callback) {
    var loadInterval = setInterval(function () {
      if (window.loaded == 100) {
        clearInterval(loadInterval);
        callback();
      }
    }, 200);
  }

  /*==============================================*/

  function scrollTo() {
    $('a[href*="#"]:not([href="#"])').click(function () {
      if (
        location.pathname.replace(/^\//, "") ==
        this.pathname.replace(/^\//, "") &&
        location.hostname == this.hostname
      ) {
        var target = $(this.hash);
        target = target.length
          ? target
          : $("[name=" + this.hash.slice(1) + "]");
        if (target.length) {
          $("html, body").animate(
            {
              scrollTop: target.offset().top,
            },
            1000
          );
          return false;
        }
      }
    });
  }

  function aspam_function() {
    jQuery(".email").each(function () {
      const $el = jQuery(this);
      const email = `${$el.data("user")}@${$el.data("domain")}`;
      const inner = $el.html().trim();

      if (inner === '') {
        $el.html(`<a href="mailto:${email}">${email}</a>`);
      } else {
        $el.html(`<a href="mailto:${email}">${inner}</a>`);
      }
    });
  }

  function add_transitions_delay_to_countries() {
    if ($("#aa_global_map").length) {
      $("#aa_global_map")
        .find("path")
        .each(function (index, item) {
          var delay = index / 200;
          $(this).css("transition-delay", delay + "s");
        });
    }
  }

  /*==========================navigation=======================================*/

  function aa_move_submenu_on_hover(item) {
    var offset = item.offset();
    var left = offset.left;
    var id = item.attr("id");
    var cont = $(".wp-block-navigation__submenu-container");
    var iwidth = item.outerWidth();
    var smid = id.replace("menu-item-", "submenu-");

    if ($("#" + smid).length == 0) {
      cont.css("pointer-events", "none").css("z-index", "-1");
      gsap.to(cont, {
        duration: 0.5,
        scale: 0.9,
        opacity: 0,
        ease: "power1.out",
      });
      return false;
    }

    var sm = $("#aa_submenu_container");
    var mainsm = $(".wp-block-navigation__submenu-container");

    var smoffset = mainsm.offset();
    var smleft = smoffset.left;
    var smwidth = mainsm.outerWidth();

    smmove = 0;
    smmove = left - smleft;

    gsap.to(mainsm, {
      duration: 0.6,
      x: "+=" + smmove,
      scale: 1,
      opacity: 1,
      ease: "power2.inOut",
    });

    $(".aa_submenu").removeClass("show");
    $("#" + smid).addClass("show");

    var height = $("#aa_main_submenu_container").find(".show").outerHeight();
    var width = $("#aa_main_submenu_container").find(".show").outerWidth();
    gsap.to(sm, {
      duration: 0.3,
      height: height,
      width: width,
      ease: "power1.out",
    });

    $(".wp_aad_menu_item").removeClass("hovering");
    item.addClass("hovering");

    return true;
  }

  function aa_add_sm_animation() {
    $(".aa_main_menu_item").each(function () {
      $(this).on("mouseenter", function () {
        aa_move_submenu_on_hover($(this));
      });
    });
  }

  function aa_toggle_submenu() {
    var cont1 = document.getElementById("main-navigation");
    var cont2 = document.getElementById("aa_main_submenu_container");

    aa_hover_submenu($("#main-navigation"));
    aa_hover_submenu($("#aa_main_submenu_container"));

    $(".wp_aad_menu_item").each(function () {
      $(this).on("mouseenter", function () {
        if (aa_move_submenu_on_hover($(this))) {
          $("#aa_main_submenu_container")
            .css("pointer-events", "auto")
            .css("z-index", "9999");
        }
      });
    });

    $(document).on("mousemove", function () {
      if (!window.mouseIsOver) {
        $("#aa_main_submenu_container")
          .css("pointer-events", "none")
          .css("z-index", "-1");
        gsap.to($("#aa_main_submenu_container"), {
          duration: 0.5,
          scale: 0.9,
          opacity: 0,
          ease: "power1.out",
        });
        $(".wp_aad_menu_item").removeClass("hovering");
      }
    });

    /*================================*/

    $("#aa_responsive_slider_nav")
      .find(".aa_main_menu_item")
      .each(function () {
        var li = $(this);
        $(this)
          .find("a.main_menu_btn")
          .click(function (e) {
            e.preventDefault();
            if (li.hasClass("opened")) {
              li.find(".aa_submenu_single_list").css("height", 0);
              li.removeClass("opened");
            } else {
              var smul = li.find(".aa_submenu_single_list");
              li.addClass("opened");

              var ulheight = 0;
              smul.find("li").each(function () {
                //console.log('found ' + $(this).outerHeight());
                ulheight += $(this).outerHeight();
              });

              li.find(".aa_submenu_single_list").css("height", ulheight + "px");
            }
          });
      });
  }

  function aa_hover_submenu(div) {
    window.mouseIsOver = false;
    div = div || -1;
    if (div.length) {
      div.mouseover(function (event) {
        window.mouseIsOver = true;
      });
      div.mouseout(function (event) {
        window.mouseIsOver = false;
      });
    }
  }

  function aa_open_lang_switcher() {
    var container = $("#aa_lang_switcher");
    var thisHeight = container.height();
    var list = container.find("ul");

    container.click(function () {
      //console.log(thisHeight);
      var listHeight = list.outerHeight();
      if (!$(this).hasClass("opened")) {
        $(this).addClass("opened");
        $(this).css("height", listHeight + "px");
      } else {
        $(this).removeClass("opened");
        container.css("height", "40px");
      }
    });

    $(document).mouseup(function (e) {
      var container = $("#aa_lang_switcher");
      if (
        !container.is(e.target) &&
        container.has(e.target).length === 0 &&
        container.hasClass("opened")
      ) {
        container.removeClass("opened");
        container.css("height", "40px");
      }
    });
  }

  /*============*/

  function aa_toggle_responsive_menu() {
    $("#aa_resp_menu_btn").click(function () {
      var slider = $("#aa_responsive_slider_nav");
      if (slider.hasClass("opened")) {
        slider.removeClass("opened");
      } else {
        slider.addClass("opened");
      }
    });

    $(document).on("mousedown touchstart", function (e) {
      var container = $("#aa_responsive_slider_nav");
      if (
        !$("#aa_resp_menu_btn").is(e.target) &&
        !container.is(e.target) &&
        container.has(e.target).length === 0 &&
        container.hasClass("opened")
      ) {
        container.removeClass("opened");
      }
    });
  }

  function aa_toggle_responsive_menu_v2() {
    jQuery(
      '#aa_responsive_slider_nav li[id^="submenu-item"], #aa_responsive_slider_nav li[id^="submenu-item"] ul'
    ).hide();
    jQuery('#aa_responsive_slider_nav li[id^="menu-item"]')
      .after()
      .click(function () {
        if (jQuery(this).hasClass("open")) {
          //console.log("menu if");
          jQuery(this)
            .nextUntil('[id^="menu-item"]')
            .removeClass("open")
            .hide();
          jQuery(this).removeClass("open");
        } else {
          //console.log("menu else");
          jQuery(this).nextUntil('[id^="menu-item"]').show();
          jQuery(this)
            .parent()
            .find('[id^="menu-item"].open')
            .removeClass("open")
            .nextUntil('[id^="menu-item"]')
            .removeClass("open")
            .hide();
          if (!jQuery(this).next().find("a").is(":visible")) {
            //console.log("a hidden");
            jQuery(this).next().find("ul, li").show();
          }
          // jQuery(this).parent().find('li[id^="submenu-item"]').hide().removeClass('open');
          jQuery(this).addClass("open");
        }
      });

    jQuery(
      '#aa_responsive_slider_nav li[id^="submenu-item"].level_1_item a'
    ).click(function () {
      if (jQuery(this).parent().hasClass("open")) {
        //console.log("submenu if");
        jQuery(this)
          .parent()
          .find('ul, li[id^="submenu-item"]')
          .hide()
          .removeClass("open");
        jQuery(this).parent().removeClass("open");
      } else {
        //console.log("submenu else");
        jQuery(this).parent().parent().find('li[id^="submenu-item"] ul').hide();
        jQuery(this)
          .parent()
          .parent()
          .find('li[id^="submenu-item"]')
          .removeClass("open");
        jQuery(this).parent().find('ul, li[id^="submenu-item"]').show();
        jQuery(this).parent().addClass("open");
      }
    });
  }

  function header_responsive() {
    if (jQuery("body").width() <= 1000) {
      jQuery("header").addClass("fbox fb-jsb valign");
      jQuery("#logo img.desktop").addClass("hide");
      jQuery("#logo img.mobile").removeClass("hide");
      mobile_menu_scroll();
      hero_background();
    } else {
      jQuery("header").removeClass("fbox fb-jsb valign");
      jQuery("#logo img.desktop").removeClass("hide");
      jQuery("#logo img.mobile").addClass("hide");
    }
  }

  function mobile_menu_scroll() {
    jQuery(window)
      .off("scroll.aaHeaderScroll")
      .on("scroll.aaHeaderScroll", function () {
        if (
          jQuery(window).scrollTop() != 0 ||
          jQuery(window).scrollTop() > $(window).height()
        ) {
          jQuery("header").addClass("scrolling");
          jQuery("#logo").addClass("scrolling");
          if (jQuery(window).width() <= HEADER_RESPONSIVE_BREAKPOINT) {
            change_logo_color("white");
          }
        } else {
          jQuery("header").removeClass("scrolling");
          jQuery("#logo").removeClass("scrolling");
          hero_background();
        }
      });
  }

  // Reparte delays/duraciones al azar entre las bg_column de cada hero, sin
  // importar cuantas haya. Se ejecuta antes de anadir "loaded" (lo que dispara
  // la transicion CSS), asi que las custom properties ya estan listas a tiempo.
  // --col-delay/--line-delay/--col-duration/--line-duration tienen prioridad
  // sobre el --i/--line-i secuencial que deja Gutenberg (ver global.css), que
  // sigue sirviendo de respaldo si este script no llega a ejecutarse.
  function randomize_hero_stripes() {
    $(".background_stripes").each(function () {
      var cols = $(this).find(".bg_column");
      var count = cols.length;
      if (!count) {
        return;
      }

      var colSpread = Math.min(1.2, 0.15 * count);
      var lineBase = 1.2;
      var lineSpread = Math.min(1.2, 0.15 * count);

      cols.each(function () {
        var colDelay = Math.random() * colSpread;
        var lineDelay = lineBase + Math.random() * lineSpread;
        var colDuration = 1.2 + Math.random() * 0.6;
        var lineDuration = 0.8 + Math.random() * 0.6;

        this.style.setProperty("--col-delay", colDelay.toFixed(3) + "s");
        this.style.setProperty("--line-delay", lineDelay.toFixed(3) + "s");
        this.style.setProperty("--col-duration", colDuration.toFixed(3) + "s");
        this.style.setProperty("--line-duration", lineDuration.toFixed(3) + "s");
      });
    });
  }

  function hero_background() {
    const viewportWidth = jQuery(window).width();

    // Responsive behavior: logo is always white.
    if (viewportWidth <= HEADER_RESPONSIVE_BREAKPOINT) {
      change_logo_color("white");
      return;
    }

    // Desktop behavior: honor PHP metadata class; default is blue.
    if (jQuery("body").hasClass("brand-color-white")) {
      change_logo_color("white");
    } else {
      change_logo_color("blue");
    }
  }

  function change_logo_color(newColor) {
    var logo_img = jQuery("header #logo .wp-block-site-logo img").first();
    if (!logo_img.length) {
      logo_img = jQuery("header .wp-block-site-logo img").first();
    }
    if (!logo_img.length) {
      return;
    }

    var logo_url = logo_img.attr("src");
    if (!logo_url || (logo_url.indexOf("blue") < 0 && logo_url.indexOf("white") < 0)) {
      return;
    }

    var currentColor = logo_url.indexOf("blue") > 0 ? "blue" : "white";
    if (currentColor === newColor) {
      return;
    }

    var logo_srcset = logo_img.attr("srcset");
    logo_img.attr("src", logo_url.replace(currentColor, newColor));
    if (logo_srcset && (logo_srcset.indexOf("blue") > -1 || logo_srcset.indexOf("white") > -1)) {
      logo_img.attr("srcset", logo_srcset.replace(new RegExp(currentColor, "g"), newColor));
    }
  }

  function hamburger_menu() {
    //Hamburger menu
    var menuContainer = $("#aa_responsive_slider_nav");
    var menuButton = $("#menu_btn");

    menuButton.click(function () {
      menuContainer.toggleClass("closed").toggleClass("opened");
      menuButton.toggleClass("closed").toggleClass("opened");
    });

    $(window).resize(function () {
      if ($(window).width() > 1000) {
        if (menuContainer.hasClass("opened")) {
          menuContainer.removeClass("opened").addClass("closed");
          menuButton.removeClass("opened").addClass("closed");
        }
      }
    });
  }

  function parallax_scroll(target, container, direction, axis, speed, type) {
    if (container.length && target.length) {
      direction = direction || -1;
      axis = axis || "y";
      speed = speed || 1;
      type = type || "normal";

      let containerOffset = container.offset();
      let targetOffset = target.offset();
      /* ToDo check height on resize */
      if (type == "image") {
        var imgHeight = container.find("img").height();
        var imgWidth = container.find("img").width();
        container.css({
          height: imgHeight * 0.85 + "px",
          maxHeight: imgHeight * 0.9 + "px",
        });
        //console.log(container.find("img").attr("src").indexOf(".png") >= 0);
        container.find("img").css({
          height: imgHeight * 1 + "px",
          maxWidth: "none",
          top: "0",
          objectFit:
            container.find("img").attr("src").indexOf(".png") >= 0
              ? "contain"
              : "cover",
        });
        //console.log(imgHeight * 4);
      }

      let st = window.pageYOffset || document.documentElement.scrollTop;

      let amount = (st - containerOffset.top) * direction;

      if (axis == "x") {
        gsap.to(target, {
          duration: 1,
          x: amount / (5 / speed),
          ease: "power1.out",
        });
      } else {
        gsap.to(target, {
          duration: 1,
          y: amount / (10 / speed),
          ease: "power1.out",
        });
      }

      //let startPoint =  containerOffset.top + (containerOffset.top - targetOffset.top);

      $(window).scroll(function () {
        let st = window.pageYOffset || document.documentElement.scrollTop;

        let amount = (st - containerOffset.top) * direction;

        if (axis == "x") {
          gsap.to(target, {
            duration: 1,
            x: amount / (5 / speed),
            ease: "power1.out",
          });
        } else {
          gsap.to(target, {
            duration: 1,
            y: amount / (10 / speed),
            ease: "power1.out",
          });
        }
      });
    }
  }

  function showup(seccion, delay) {
    $(document).ready(function () {
      if (seccion.length > 0) {
        var secPos = seccion.offset();
        var secID = seccion.get(0).id;
        var windowHeight = $(window).height();
        var windowTH = $(window).scrollTop() + windowHeight - 150;
        if (secPos.top < windowTH) {
          seccion.addClass("animate");
        }
      }
    });

    $(window).scroll(function () {
      if (delay === null) {
        delay = 0.9;
      }
      if (seccion.length > 0) {
        var secPos = seccion.offset();
        var secID = seccion.get(0).id;
        var windowHeight = $(window).height() * delay;
        var windowTH = $(window).scrollTop() + windowHeight;
        if (secPos.top < windowTH) {
          seccion.addClass("animate");
        }
      }
    });
  }

  /*=============================*/

  function move_compass() {
    $("body.home .wp-block-allaround-hero").mousemove(function (e) {
      var wwidth = $(window).width();
      var rotationRaw = e.pageX - wwidth / 2;
      var rotation = (rotationRaw * 80) / wwidth;

      gsap.to("#dashed_ring", {
        duration: 3,
        rotationZ: rotation,
        ease: "power3.out",
      });
      gsap.to("#arrow", {
        duration: 2,
        rotationZ: rotation,
        ease: "power3.out",
      });
    });
  }

  /*=============================*/

  function lang_navigation() {
    $("#lang_nav > span").click(function () {
      $("#lang_nav").toggleClass("opened");
    });

    $(document).mouseup(function (e) {
      var container = $("#lang_nav");
      if (
        !container.is(e.target) &&
        container.has(e.target).length === 0 &&
        $("#lang_nav").hasClass("opened")
      ) {
        container.removeClass("opened");
      }
    });
  }
});

function hide_empty_blog() {
  if (jQuery("#related_posts").children().length == 0) {
    jQuery("#related_posts").parent().hide();
  }
}
// export { showup };
